import { z } from "zod";

export const usPostalCodeSchema = z.string().regex(/^\d{5}(?:-\d{4})?$/, "Enter a valid ZIP code");

export const addressSchema = z.object({
  line1: z.string().nullable(),
  line2: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  postalCode: z.string().nullable(),
  country: z.string().nullable(),
  /** Google Places ID when the address was selected from geocoding autocomplete. */
  placeId: z.string().nullable().optional(),
});

export type Address = z.infer<typeof addressSchema>;
